const defaultPattern: { text: string; key: string }[] = [
  {
    key: 'hours',
    text: 'hrs',
  },
  {
    key: '1',
    text: '',
  },
  {
    key: 'minutes',
    text: 'min',
  },
  {
    key: '2',
    text: '',
  },
  {
    key: 'seconds',
    text: 'sec',
  },
];

export { defaultPattern };
